import React from 'react';
import PropTypes from 'prop-types';

import LeaderboardItem, { leaderboardItemShape } from './leaderboardItem';
import { LeaderboardsList } from '../../styled';

const LeaderboardList = ({ leaderboards }) => {
  return (
    <LeaderboardsList>
      {
        leaderboards.map((leaderboard) => (
          <LeaderboardItem
            key={leaderboard.user.id}
            id={leaderboard.user.id}
            {...leaderboard}
          />
        ))
      }
    </LeaderboardsList>
  );
};

LeaderboardList.propTypes = {
  leaderboards: PropTypes.arrayOf(PropTypes.shape(leaderboardItemShape)).isRequired,
};

export default LeaderboardList;
